<template>
  <div>
    <SearchComponent
      :isAdd="true"
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
      @on-add="handleAdd"
      :authIdentity="authIdentity"
    ></SearchComponent>
    <TablePublic
      :colLists="colLists"
      :tableData="tableData"
      :total="total"
      :summary="true"
      :summaryMethod="getSummaries"
      :pageParams="queryParams"
      @pageChange="getList"
    >
      <template slot="percentage" slot-scope="scope">
        <div class="progress">
          <el-progress
            color="#c59429"
            :stroke-width="10"
            type="circle"
            :percentage="scope.data.percentage"
          ></el-progress>
        </div>
      </template>
      <template slot="solts" slot-scope="scope">
        <el-button
          class="button"
          type="text"
          size="small"
          v-hasPermi="[authIdentity + ':edit']"
          @click="handleUpdate(scope.data, '修改')"
        >修改</el-button>
        <el-button
          v-hasPermi="[authIdentity + ':detail']"
          @click="handleView(scope.data, scope.$index)"
          type="text"
          size="small"
          class="button"
        >详情</el-button>
        <el-button
          v-hasPermi="[authIdentity + ':del']"
          @click="handleDel(scope.data, '删除')"
          type="text"
          size="small"
          class="delbutton"
        >删除</el-button>
        <el-button
          v-hasPermi="[authIdentity + ':proDetail']"
          @click="proDetail(scope.data, scope.$index)"
          type="text"
          size="small"
          class="button"
        >计划采摘明细</el-button>
      </template>
    </TablePublic>
    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      @closes="cancel"
    >
      <component
        v-if="dialogVisible"
        :ref="currentView"
        :is="currentView"
        :type="type"
        @on-upload="handleFile"
      ></component>
      <span slot="footer" v-if="type != 'preview'">
        <el-button :disabled="loading || fileUploading" class="batch-button" @click="cancel">取 消</el-button>
        <el-button
          :disabled="fileUploading"
          :loading="loading"
          class="line-button"
          @click="submitFrom"
        >确 定</el-button>
      </span>
    </Mdialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getPurchasePlanList, delPurchasePlan } from '@/api/system/manage'
import { getDropFactoryList } from '@/api/system/manage'
import SearchComponent from '@/components/searchComponent'
import Mdialog from '@/components/Mdialog'
import TablePublic from '@/components/tablePublic'
import Myform from '@/views/procure/plan/components/form'
import Detail from '@/views/procure/plan/components/detail'
export default {
  components: {
    TablePublic,
    SearchComponent,
    Mdialog,
    Myform,
    Detail,
  },
  data() {
    return {
      loading: false,
      fileUploading: false,
      authIdentity: 'procure:plan',
      dialogVisible: false,
      title: '',
      currentView: '',
      type: '',
      colLists: [
        {
          prop: 'bizNo',
          label: '采购计划单号',
          isTrue: true,
        },
        {
          prop: 'name',
          label: '计划名称',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'customerName',
          label: '客户名称',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'cultivationMethodSpecValueNames',
          label: '培育方式',
          isTrue: true,
          align: 'left',
        },
        {
          prop: 'totalPlanToPurchaseNetWeight',
          label: '计划采购总净重(斤)',
          width: 150,
          isTrue: true,
        },
        {
          prop: 'totalPlanToPickTotalNetWeight',
          label: '已计划采摘总净重(斤)',
          width: 160,
          isTrue: true,
        },
        {
          prop: 'percentage',
          label: '计划采摘进度(%)',
          isTrue: true,
          formSolt: true,
        },
        {
          prop: 'plantationNames',
          label: '计划采摘果园名称',
          isTrue: true,
          width: 140,
          align: 'left',
        },
        {
          prop: 'pickingBatchNumber',
          label: '计划采摘数',
          isTrue: true,
        },
        {
          prop: 'createDate',
          label: '计划日期',
          width: 110,
          isTrue: true,
        },

        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 260,
          rightFlag: true,
        },
      ],
      total: 0,
      queryParams: {},
      tableData: [],
      selectOrInputList: [
        {
          model: 'customerName',
          placeholder: '请选择客户',
          value: 'name',
          label: 'name',
          list: [],
          type: 'select',
        },
        {
          model: 'bizNo',
          placeholder: '请输入单号',
          class: 'home',
          type: 'input',
        },
        {
          model: 'name',
          placeholder: '请输入计划名称',
          class: 'home',
          type: 'input',
        },
      ],
    }
  },
  created() {
    this.getDictList({ types: 'cultivationMethod,ripenessLevel' })
    this.getDropFactoryList()
    this.getList()
  },
  methods: {
    ...mapActions({ getDictList: 'system/getDictList' }),
    getDropFactoryList(){
      getDropFactoryList({type: 1}).then((res) => {
        if (res.flag) {
          this.selectOrInputList[0].list = res.data
        }
      })
    },
    getList(pageData) {
      if (pageData) {
        this.queryParams = Object.assign(this.queryParams, pageData)
      }
      getPurchasePlanList(this.queryParams)
        .then((res) => {
          if (res.flag) {
            this.tableData = res.data.items.map((item) => {
              item.createDate = this.parseTime(item.createTime, '{y}-{m}-{d}')
              item.plantationNames = item.plantationName && item.plantationName.join(',')
              item.cultivationMethodSpecValueNames =
                item.cultivationMethodSpecValueKeyList && item.cultivationMethodSpecValueKeyList.join(',')
              item.percentage = this.myFixed(
                (item.totalPlanToPickTotalNetWeight / item.totalPlanToPurchaseNetWeight) * 100,
                2
              )
              return item
            })
            this.total = res.data.totalCount
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleFile(file) {
      this.fileUploading = file.fileUploading
    },
    submitFrom() {
      this.loading = true
      this.$refs[this.currentView]
        .submit()
        .then(() => {
          this.loading = false
          this.fileUploading = false
          this.cancel()
          this.getList()
        })
        .catch(() => {
          this.loading = false
          this.fileUploading = false
        })
    },
    cancel() {
      if (this.loading || this.fileUploading) {
        return
      }
      // this.$refs[this.currentView].reset()
      this.dialogVisible = false
    },
    handleView(row) {
      this.type = 'preview'
      this.title = '查看采购计划'
      this.dialogVisible = true
      this.currentView = 'Detail'
      this.$nextTick(() => {
        if (row) {
          this.$refs[this.currentView].getDetails(row)
        }
      })
    },
    proDetail(row) {
      this.$store.commit('manage/SET_INFO_DETAIL', row)
      this.$router.push('/proDetail')
    },
    handleAdd() {
      this.type = 'save'
      this.title = '新增采购计划'
      this.dialogVisible = true
      this.currentView = 'Myform'
    },
    handleUpdate(row) {
      this.type = 'update'
      this.title = '修改采购计划'
      this.dialogVisible = true
      this.currentView = 'Myform'
      this.$nextTick(() => {
        if (row) {
          this.$refs[this.currentView].getDetails(row)
        }
      })
    },
    // 删除
    handleDel(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonClass: 'confirm_button',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          delPurchasePlan(row.id).then((response) => {
            if (response.code == 200 && response.flag) {
              this.$message.success(`删除成功！`)
              this.getList()
            } else {
              this.$message.warning(response.message)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    handleSearch(query) {
      this.queryParams.pageNo = 1
      this.queryParams = Object.assign(this.queryParams, query)
      this.getList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
      }
      this.getList()
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 5) {
          sums[index] = this.sumArr(data, 'totalPlanToPurchaseNetWeight') || '-'
        }
        if (index === 6) {
          sums[index] = this.sumArr(data, 'totalPlanToPickTotalNetWeight') || '-'
        }
        if (index === 9) {
          sums[index] = this.sumArr(data, 'pickingBatchNumber') || '-'
        }
      })
      return sums //返回sums数组,sums数组中各项就会显示在合计行的各列中
    },
  },
}
</script>
<style scoped lang='less'>
@import '~@/assets/tableList.less';
.progress {
  height: 48px;
  display: flex;
  justify-content: center;
}
/deep/ .el-progress-circle {
  width: 48px !important;
  height: 48px !important;
}
/deep/ .el-progress__text {
  font-size: 12px !important;
}
.progress {
  margin-bottom: 0px;
  padding-bottom: 0px;
  // width: 50px;
  // height: 50px;
}
// @import '../../../../assets/form.less';
</style>